import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicForm from "./DynamicForm";

const EmployeeDashboard = () => {
  const dispatch = useDispatch();

  return (
    <div className="w-full h-[10] flex  ">
      <img className="w-[60%] h-screen" src="/formPic.png" alt="FormImage"/>
      <div className="w-[40%]">
      <DynamicForm />
      </div>
    </div>
  );
};

export default EmployeeDashboard;
